import React, { Component } from 'react';

import BasicBuildingBlocks from './detailedReport/basic-building-blocks';
import Signature from "./detailedReport/signature";
import TrustedList from './detailedReport/trusted-list';
import Title from './detailedReport/title';
import DocumentInformation from './detailedReport/document-information';
import { Container, Card } from 'react-bootstrap';
import i18n from '../../i18n';

import * as Constants from '../../constants/constants'

const titleStyle = {
	backgroundColor: Constants.MAIN_COLOR,
	color: "#fff",
	fontWeight: "bold",
	fontSize: "18px"
}

export default class DetailedReport extends Component {
	constructor(props) {
		super(props);
		//console.log(this.props.report);
	}

	render() {
		return (
			<div className="container">
				<section>
					<Title reportId={this.props.reportId} />
				</section>
				<br />
				<section>
					<DocumentInformation signatures={this.props.report.signatures} documentName={this.props.documentName}
						reportGenerationTime={this.props.reportGenerationTime} permLinkValidUntil={this.props.permLinkValidUntil}
						hash={this.props.hash} linkId={this.props.linkId} language={this.props.language} />
				</section>
				<br />
				{this.props.report.signatures.length > 0 ?
					<section>

						<Card.Header style={titleStyle}>
							{i18n.t("docInfo:signatures")}
						</Card.Header>
						{this.props.report.signatures.map((signatures, i) => {
							return <div key={i}><Signature data={signatures} index={i} handleKeyUp={this.props.handleKeyUp} /></div>
						})}
						<br />
					</section>
					: null
				}
				{this.props.report.basicBuildingBlocks.length > 0 ?
					<section>

						<Card.Header style={titleStyle}>
							{i18n.t("detailed:basic_building_blocks")}
						</Card.Header>
						{this.props.report.basicBuildingBlocks.map((basicBuildingBlocks, i) => {
							return <div key={i}><BasicBuildingBlocks data={basicBuildingBlocks} handleKeyUp={this.props.handleKeyUp} /></div>
						})}

						<br />
					</section>
					: null
				}
				{this.props.report.tlanalysis.length > 0 ?
					<section>
						<Card.Header style={titleStyle}>
							{i18n.t("detailed:tl_analysis")}
						</Card.Header>
						{this.props.report.tlanalysis.map((tlanalysis, i) => {
							return <div key={i}><TrustedList data={tlanalysis} handleKeyUp={this.props.handleKeyUp} /></div>
						})}
					</section>
					: null
				}
			</div>
		);
	}
}